// @flow
// $FlowFixMe
import React, { useMemo } from "react";
import { noop } from "lodash";
import type { RaceTypeCodeEnum } from "@tvg/types/Race";
import type { BinaryFn } from "@tvg/types/Functional";
import RunnerNumber from "../RunnerNumber";
import { ButtonContainer, RunnerName } from "./styled-components";

type Props = {
  isActive: boolean,
  runnerId: string,
  runnerName: string,
  entityRunnerId: string,
  raceTypeCode: RaceTypeCodeEnum,
  onRunnerClick: BinaryFn<string, string, void>
};

const RunnerButton = (props: Props) => {
  const {
    runnerId,
    raceTypeCode,
    runnerName,
    entityRunnerId,
    onRunnerClick,
    isActive
  } = props;

  return useMemo(
    () => (
      <ButtonContainer
        isActive={isActive}
        onClick={() => onRunnerClick(entityRunnerId, runnerName)}
      >
        <RunnerNumber raceTypeCode={raceTypeCode} runnerId={runnerId} />
        <RunnerName isActive={isActive}>{runnerName}</RunnerName>
      </ButtonContainer>
    ),
    [isActive, runnerName]
  );
};

RunnerButton.defaultProps = {
  onRunnerClick: noop,
  runnerId: "",
  entityRunnerId: "",
  runnerName: "",
  raceTypeCode: "T"
};

export default RunnerButton;
